import React from "react";
import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

export default function CustomeCircularProgressbar({ percentage }) {
  return (
    <CircularProgressbar
      value={percentage}
      text={`${percentage}%`}
      className="custom-progress-bar"
      counterClockwise
      styles={buildStyles({
        backgroundColor: "red",
        textColor: "#08AF22",
        trailColor: "#fff",
        pathColor: "#08AF22",
        
      })}
    />
  );
}
